module.exports = __webpack_public_path__ + "static/media/marker-done.f89bb1cb.png";